/* istanbul ignore file */
import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { useShowContext } from 'framework/show';
import type { Data } from 'framework/types';

type Props = {
  FeedbackButton: React.ComponentType<{ entity: Data }>;
};

const FlagAsInappropriateTimelineRecordButton = ({ FeedbackButton }: Props) => {
  const { data: entity } = useShowContext();

  return (
    <MenuItem className="flag-toggler">
      <FeedbackButton entity={entity} />
    </MenuItem>
  );
};

export default FlagAsInappropriateTimelineRecordButton;
